const NAME = 'star';

const VIEWBOX = '0 0 500 500';

const CONTENTS = `
  <path d="M250 21.3L324.3 172l166.2 24-120.3 117.2 28.4 165.5-148.6-78-148.6 78 28.4-165.5L9.5 196l166.2-24z"/>
`;

const SYMBOL_MARKUP = `<symbol id="tn-syos-seat-map-icon-${NAME}" viewBox="${VIEWBOX}">${CONTENTS}</symbol>`;

function getSvgMarkup(label = 'Star') {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${VIEWBOX}" role="img" focusable="false" aria-label="${label}">${CONTENTS}</svg>`;
}

export default {
  getSvgMarkup,
  SYMBOL_MARKUP,
};



// WEBPACK FOOTER //
// ./V7/syos/seatIcons/Star.js